var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Left',{attrs:{"menu":_vm.menu},on:{"update:menu":function($event){_vm.menu=$event},"update":_vm.update}}),_c('div',{staticClass:"acticle",class:!_vm.MENU_INDENT ? 'open' : 'close'},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }